const cmsEvents = {
    FETCH_CMS_DATA_SUCCESS: 'cms/fetch_data_success',
    FETCH_CMS_DATA_PROGRESS: 'cms/fetch_data_progress',
    FETCH_CMS_DATA_FAILED: 'cms/fetch_data_failed',
  };

export default cmsEvents;
